import type { QuoteArea } from 'paintscout'
import type { QuoteItemSection } from '../..'
import { getItemSection } from '../../util'

/**
 * Clean an area of any substrates not in the given section.
 * @param area Area to clean substrates in
 * @param section keep substrates in this section, if none given keep all
 * @returns
 */
export default function getSectionSubstrates(area: QuoteArea, section?: QuoteItemSection): QuoteArea {
  // Check area substrates, keep if in section
  const res = Object.keys(area.substrates).reduce(
    (acc, substrateKey) => {
      const rateSection = area.substrates[substrateKey]

      rateSection.forEach((rate) => {
        if (section) {
          const itemSection = getItemSection(rate)
          // Include items in same section, unless copying from bid,
          // Then we include archived and options as well.
          if (itemSection == section || (section == 'bid' && ['archived', 'options'].includes(itemSection))) {
            acc.newSubstrates = {
              ...acc.newSubstrates,
              [substrateKey]: acc.newSubstrates[substrateKey] ? [...acc.newSubstrates[substrateKey], rate] : [rate]
            }
            acc.newOrder.push({
              key: rate.key,
              type: 'areaSubstrate'
            })
          }
        } else {
          acc.newSubstrates = {
            ...acc.newSubstrates,
            [substrateKey]: acc.newSubstrates[substrateKey] ? [...acc.newSubstrates[substrateKey], rate] : [rate]
          }
          acc.newOrder.push({
            key: rate.key,
            type: 'areaSubstrate'
          })
        }
      })

      return acc
    },
    { newOrder: [], newSubstrates: {} }
  )
  // Retain old order with new items
  const orderedOrder = area.substrateOrder.filter((oldOrderItem) => {
    return res.newOrder.filter((newOrderItem) => newOrderItem.key === oldOrderItem.key).length > 0
  })

  const cleanArea = {
    ...area,
    substrateOrder: orderedOrder,
    substrates: res.newSubstrates
  }

  return cleanArea
}
